import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getEventName } from '../../../name-helpers/eventNameHelper';
import { capitalize } from '../../../name-helpers/nameFormatter';
import Tabs from "../tabs.component";

class SchedulingTabs extends Component {

    constructor(props, context) {
        super(props, context)
    }


    render() {
        return (
            <Tabs value={[
                {
                    name: <FormattedMessage
                        id="menu.tabs.scheduling.events_tab"
                        defaultMessage="{eventName}s"
                        values={{ eventName: capitalize(getEventName(this.props.intl)) }}
                    />,
                    link: '/calendar-events/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.scheduling.pages"
                        defaultMessage="Scheduling pages"
                    />,
                    link: '/scheduling-pages/listing',
                },
            ]} />
        );
    }
}

export default injectIntl(SchedulingTabs)


// WEBPACK FOOTER //
// ./src/common/layout/tabs/scheduling.component.jsx